<template>
  <v-dialog v-model="dialog" max-width="500px" :persistent="loading" @click:outside="close">
    <v-card v-if="!!payment && !!rental">
      <v-card-title class="justify-center text-center"> Dar Baixa </v-card-title>
      <v-card-text class="d-flex flex-column align-center">
        <v-alert type="info" text> Abaixo você pode informar os valores de juros, multa e desconto. </v-alert>
        <v-form v-model="valid" @submit.prevent>
          <v-row>
            <v-col cols="12">
              <bank-selector
                v-model="discharge.bankId"
                label="Banco"
                outlined
                dense
                smallChips
                :rules="rulesBank"
                :chips="true"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="discharge.payDate"
                label="Data de Pagamento"
                type="date"
                outlined
                dense
                hide-details="auto"
                :rules="rulesDate"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field-money
                v-model="discharge.fees"
                label="Juros"
                :properties="{
                  prefix: 'R$',
                  outlined: true,
                  dense: true,
                  placeholder: ' ',
                  hideDetails: true,
                  rules: rulesValue,
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: '0',
                }"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field-money
                v-model="discharge.penalty"
                label="Multa"
                :properties="{
                  prefix: 'R$',
                  outlined: true,
                  dense: true,
                  placeholder: ' ',
                  hideDetails: true,
                  rules: rulesValue,
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 11,
                  precision: 2,
                  empty: '0',
                }"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="mt-4">
        <v-btn color="primary" outlined @click="close" :disabled="loading">Fechar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="processDischarge" depressed :loading="loading" :disabled="!valid">
          Dar Baixa
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import RENTAL from '@/services/rental'
import BankSelector from '@/components/global/BankSelector.vue'

export default {
  components: { BankSelector },
  data() {
    return {
      dialog: false,
      loading: false,
      payment: null,
      rental: null,
      valid: false,
      rulesDate: [v => !!v || 'Data de pagamento é obrigatória'],
      rulesBank: [v => !!v || 'Banco é obrigatório'],
      discharge: {
        fees: 0,
        penalty: 0,
        discount: null,
        payDate: null,
        bankId: null,
      },
    }
  },
  methods: {
    async processDischarge() {
      try {
        this.loading = true
        await RENTAL.payment.discharge(this.rental.id, this.payment.id, this.discharge)
        this.$emit('success')
        this.loading = false
        this.close()
      } catch (error) {
        this.loading = false
        this.$toast.fire({
          icon: 'error',
          title: error.message || 'Erro ao excluir usuário',
        })
      }
    },
    close() {
      if (this.loading) return
      this.dialog = false
      this.loading = false
      this.payment = null
      this.rental = null
    },
    open({ payment, rental }) {
      this.dialog = true
      this.payment = payment
      this.rental = rental
      this.discharge = {
        bankId: null,
        payDate: null,
        fees: 0,
        penalty: 0,
      }
    },
  },
  mounted() {
    this.$parent.$on('payment-discharge', this.open)
  },
}
</script>

<style></style>
